/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Ui_HomeInputs */

const en_wc_tut_ui_home = /** @type {(inputs: Wc_Tut_Ui_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home: clipboard, font, paragraph, Styles gallery, find and replace.`)
};

/**
* | output |
* | --- |
* | "Home: clipboard, font, paragraph, Styles gallery, find and replace." |
*
* @param {Wc_Tut_Ui_HomeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_ui_home = /** @type {((inputs?: Wc_Tut_Ui_HomeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Ui_HomeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_ui_home(inputs)
});
export { wc_tut_ui_home as "wc.tut.ui.home" }